export enum ReferralCode {
  All = 0,
  Yes = 1,
  No = 2,
  None = 9,
}

export const ReferralCodeText: Record<ReferralCode, string> = {
  [ReferralCode.All]: 'All',
  [ReferralCode.Yes]: 'With Referral',
  [ReferralCode.No]: 'Without Referral',
  [ReferralCode.None]: 'None',
};
